<template>
  <div>
    <loading :active="isLoading" :is-full-page="true" :lock-scroll="true" loader="dots" color="#0168b7"
      background-color="#ffffff" opacity="1" />

    <div v-show="!isLoading">
      <AccountPortfolio ref="portfolio" @content-loaded="onContentLoaded" />

      <div class="content-wrapper px-6 mt-6">
        <ActionItem />
      </div>

      <div class="content-wrapper px-6">
        <RecommendFund />
      </div>

      <div class="content-wrapper px-6">
        <PopularWatchFund />
      </div>

      <div class="content-wrapper px-6">
        <NewerPodcast />
      </div>

      <div class="content-wrapper px-6">
        <div class="mb-3"><GuideButton /></div>
        <SpecialPageList />
      </div>

    </div>
  </div>
</template>

<script>
import AccountPortfolio from '../components/AccountPortfolio.vue'
import ActionItem from '../components/ActionItem.vue'
import RecommendFund from '../components/RecommendFund.vue'
import NewerPodcast from '../components/NewerPodcast.vue'
import PopularWatchFund from '../components/PopularWatchFund.vue'
import GuideButton from '../components/guideButton.vue'
import SpecialPageList from '../components/SpecialPageList.vue'

import Loading from 'vue3-loading-overlay';
import 'vue3-loading-overlay/dist/vue3-loading-overlay.css';

export default {
  name: 'AxiosTest',
  components: {
    AccountPortfolio,
    ActionItem,
    RecommendFund,
    Loading,
    NewerPodcast,
    PopularWatchFund,
    GuideButton,
    SpecialPageList
  },
  data: () => ({
    isLoading: true
  }),
  // コンポーネントの生成リスナ
  created() { },
  // DOMのマウントリスナ
  mounted() { },
  methods: {
    onContentLoaded() {
      this.isLoading = false
    }
  }
}
</script>